import { useState, useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';

export default function HeroSection() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  return (
    <section id="hero" className="relative min-h-screen flex flex-col">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-900/95 via-primary-800/90 to-primary-700/85 z-[2]"></div>

      <div
        className="absolute inset-0 z-[1] bg-cover bg-center"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=Elegant%20antique%20golden%20balance%20scale%20of%20justice%20centered%20on%20a%20dark%20wooden%20desk%20soft%20warm%20dramatic%20lighting%20from%20above%20creating%20delicate%20shadows%20dark%20olive%20green%20background%20with%20subtle%20textured%20wall%20rich%20leather%20and%20wood%20tones%20minimalist%20composition%20luxurious%20refined%20atmosphere%20editorial%20photography%20style%20with%20soft%20depth%20of%20field&width=1600&height=1000&seq=hero-gou-bg-v2&orientation=landscape)`,
        }}
      ></div>

      <Navbar transparent={true} />

      <div className="relative z-10 flex-1 flex items-center">
        <div className="w-full max-w-[1280px] mx-auto px-6 md:px-10">
          <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-0">
            <div className={`w-full transition-all duration-1000 ease-out ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
              <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-[1.05] mb-8">
                GOU Estudio&nbsp;<span style={{ color: 'oklch(0.82 0.07 90)', fontStyle: 'italic', fontWeight: 400 }}>jurídico</span>
              </h1>

              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mb-10">
                <a
                  href="#contact"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="px-8 py-3.5 rounded-full text-sm font-semibold tracking-widest uppercase transition-all duration-300 cursor-pointer whitespace-nowrap bg-accent-500 text-white hover:bg-accent-400 hover:scale-[1.03] active:scale-[0.97] animate-subtle-glow"
                >
                  Agendar Consulta
                </a>
                <a
                  href="#services"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('#services')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="px-8 py-3.5 rounded-full border border-white/30 text-white text-sm font-semibold tracking-widest uppercase hover:border-white/60 hover:bg-white/10 hover:scale-[1.03] active:scale-[0.97] transition-all duration-300 cursor-pointer whitespace-nowrap"
                >
                  Ver Servicios
                </a>
              </div>

              <div className="border-t border-white/20 pt-8">
                <div className="grid grid-cols-3 gap-4">
                  <div className="flex flex-col items-start">
                    <span style={{ color: 'oklch(0.82 0.07 90)' }} className="font-heading text-3xl md:text-4xl font-bold leading-none mb-1">10+</span>
                    <span className="text-white/70 text-sm font-medium">Años de experiencia</span>
                  </div>
                  <div className="flex flex-col items-start border-l border-white/20 pl-4 md:pl-6">
                    <span style={{ color: 'oklch(0.82 0.07 90)' }} className="font-heading text-3xl md:text-4xl font-bold leading-none mb-1">500+</span>
                    <span className="text-white/70 text-sm font-medium">Casos resueltos</span>
                  </div>
                  <div className="flex flex-col items-start border-l border-white/20 pl-4 md:pl-6">
                    <span style={{ color: 'oklch(0.82 0.07 90)' }} className="font-heading text-3xl md:text-4xl font-bold leading-none mb-1">3</span>
                    <span className="text-white/70 text-sm font-medium">Áreas de Especialización</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <div className="w-8 h-8 rounded-full border border-white/20 flex items-center justify-center">
          <i className="ri-arrow-down-s-line text-white/60 text-sm"></i>
        </div>
      </div>

      {/* Wave bottom - transition to Services */}
      <div className="absolute bottom-0 left-0 w-full z-[3] pointer-events-none overflow-hidden"
        style={{ height: '80px', marginBottom: '-1px' }}
      >
        <svg viewBox="0 0 1440 80" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" className="w-full h-full block"
          style={{ display: 'block', filter: 'drop-shadow(0 3px 4px rgba(0, 0, 0, 0.06))' }}
        >
          <path d="M0 40C240 0 480 0 720 28C960 56 1200 56 1440 24V80H0V40Z" fill="oklch(0.94 0.008 95)" stroke="none" />
        </svg>
      </div>
    </section>
  );
}